import { render, staticRenderFns } from "./needToDo.vue?vue&type=template&id=438048aa&scoped=true"
import script from "./needToDo.vue?vue&type=script&lang=js"
export * from "./needToDo.vue?vue&type=script&lang=js"
import style0 from "./needToDo.vue?vue&type=style&index=0&id=438048aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438048aa",
  null
  
)

export default component.exports